/**
* @author ayou[beica1@outook.com]
* @date 2022/2/24 14:48
* @description
*   ThePositionLines.vue of WeTrade
*/
<template>
<div v-for="order in orders" :key="order.orderId" :class="['order p-a', {bear: order.type === 1}]"
  :style="{top: fy(order.createPrice) + 'px'}"></div>
</template>

<script lang="ts">
import state from '@/state'
import { computed, defineComponent } from 'vue'

export default defineComponent({
  name: 'ThePositionLines',
  props: {
    code: String,
    fy: {
      type: Function,
      required: true,
    },
  },
  setup (props) {
    return {
      orders: computed(() => state.account.list.filter(order => order.code === props.code)),
    }
  },
})
</script>

<style scoped lang="scss">
.order {
  width: 100%;
  border-top: 1px dashed var(--color-success);

  &.bear {
    border-color: var(--color-danger);
  }
}
</style>
